<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
        </v-card-title>
        <v-card-text>
          {{getTranslation(messageConfirm, locale)}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="color ? color : 'green darken-1'"
            text
            @click="onClose"
          >
            {{ $t('common.close', locale)}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import utils from '@/services/utils'
export default {
  props: {
    showMessageConfirm: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      required: true,
    },
    messageConfirm: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    showMessageConfirm () {
      this.dialog = this.showMessageConfirm
    },
  },
  methods: {
    getTranslation(v, locale) {
      return utils.getTranslation(v, locale)
    },
  },
}
</script>
